import React from "react";

import summaryStyles from "./summary.module.scss";
import { Card, Typography } from "@mui/material";
import { backendResponseProps, dateWithEventAndSlotListProps } from "../../../../infrastructure/GlobalContextProvider";
import { CommonButton } from "../../../common/StyledComponents/StyledFields";

interface SummaryProps {
  setShowSummaryPage: React.Dispatch<React.SetStateAction<boolean>>;
  onClickSubmit: () => void;
  registeredDataList: backendResponseProps[];
  submitDisable: boolean;
}

const Summary = (props: SummaryProps) => {
  const onClickBack = () => {
    props.setShowSummaryPage(false);
  };

  const registeredDataComponent = () => {
    return (
      <Card>
        {
          <div className={summaryStyles.tableContainer}>
            <table className={summaryStyles.tableContainer}>
              <thead className={summaryStyles.headerTableRow}>
                <tr>
                  <th className={summaryStyles.tableHorizontal}>Date</th>
                  <th className={summaryStyles.tableHorizontal}>Event Name</th>
                  <th className={summaryStyles.tableHorizontal}>Start Time</th>
                  <th className={summaryStyles.tableHorizontal}>End Time</th>
                </tr>
              </thead>
              <tbody>
                {props.registeredDataList.map((dateEvent) =>
                  dateEvent.dateWithEventAndSlotList.map((event) =>
                    event.slotsList.map((slot, slotIndex) => (
                      <tr key={slot.id} className={summaryStyles.tableRow}>
                        {slotIndex === 0 && (
                          <td
                            className={summaryStyles.tableDiagonal}
                            rowSpan={event.slotsList.length}
                          >
                            {dateEvent.date}
                          </td>
                        )}
                        <td className={summaryStyles.tableDiagonal}>
                          {event.eventName}
                        </td>
                        <td className={summaryStyles.tableDiagonal}>
                          {slot.startTime}
                        </td>
                        <td className={summaryStyles.tableDiagonal}>
                          {slot.endTime}
                        </td>
                      </tr>
                    ))
                  )
                )}
              </tbody>
            </table>
          </div>
        }
      </Card>
    );
  };

  const slotsTable = ( insideDataList: dateWithEventAndSlotListProps[]) =>
    {
      return (
        <div className={summaryStyles.tableContainer}>
          <table className={summaryStyles.tableContainer}>
            <thead className={summaryStyles.headerTableRow}>
              <tr>
                <th className={summaryStyles.tableHorizontal}>Event Name</th>
                <th className={summaryStyles.tableHorizontal}>Start Time</th>
                <th className={summaryStyles.tableHorizontal}>End Time</th>
              </tr>
            </thead>
            <tbody>
              {insideDataList.map((event) =>
                  event.slotsList.map((slot) => (
                    <tr key={slot.id} className={summaryStyles.tableRow}>
                      <td className={summaryStyles.tableDiagonal}>
                        {event.eventName}
                      </td>
                      <td className={summaryStyles.tableDiagonal}>
                        {slot.startTime}
                      </td>
                      <td className={summaryStyles.tableDiagonal}>
                        {slot.endTime}
                      </td>
                    </tr>
                  ))
                )}
            </tbody>
          </table>
        </div>
      );
    };

  const cardRegisteredData = (date: string,insideDataList: dateWithEventAndSlotListProps[]) => {
    return (
      <div className={summaryStyles.summaryCard}>
        <Typography component={"p"} className={summaryStyles.date}>
          {date}
        </Typography>
        {slotsTable(insideDataList)}
      </div>
    );
  };

  return (
    <div>
      <Typography component={"h2"} className={summaryStyles.heading}>
        Registered Slot Summary
      </Typography>
      <div className={summaryStyles.gridContainer}>
         {props.registeredDataList.map((item: backendResponseProps) => (
        <>{cardRegisteredData(item.formattedDate, item.dateWithEventAndSlotList)}</>
      ))}
      </div>
    
      <CommonButton
        onClick={onClickBack}
        sx={{ marginTop: "16px" }}
        disabled={props.submitDisable}
      >
        Back
      </CommonButton>
      <CommonButton
        onClick={props.onClickSubmit}
        sx={{ marginLeft: "16px", marginTop: "16px" }}
        disabled={props.submitDisable}
      >
        Submit
      </CommonButton>
    </div>
  );
};

export default Summary;
